const hashCode = (value: string) => {
    let hash = 0;
    if (value.length === 0) return hash;
    for (let i = 0; i < value.length; i++) {
        const chr = value.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

const sortKeys = (data: object) =>
    Object.keys(data)
        .sort()
        .reduce((obj, key) => {
            obj[key] = data[key];
            return obj;
        }, {});

export const getHashKey = (data: object) => {
    const sorted = sortKeys(data);
    return hashCode(JSON.stringify(sorted));
};
